import React from "react";

export default function QualityModal({
  open,
  onClose,
  onContinue,
}) {
  if (!open) return null;

  return (
    <div className="quality-modal-overlay">
      <div className="quality-modal">
        <div className="quality-icon">i</div>

        <h2>Revisaremos esta foto antes de prepararla</h2>

        <p>
          La resolucion es algo ajustada para este formato. Si vemos que no
          queda bien en produccion, te contactaremos antes de preparar el
          pedido.
        </p>

        <p>
          Si tienes otra version con mas calidad, mejor. Si no, puedes
          continuar tranquilamente con esta foto.
        </p>

        <div className="quality-actions">
          <button
            type="button"
            className="quality-cancel"
            onClick={onClose}
          >
            Volver a ajustar
          </button>

          <button
            type="button"
            className="quality-continue"
            onClick={onContinue}
          >
            Continuar con esta foto
          </button>
        </div>
      </div>
    </div>
  );
}
